import styled from 'styled-components';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { Grid } from '../../../Grid';

export const MarketingPromoGrid = styled(Grid)`
  position: relative;
  top: ${spacing(-3)};

  ${mediaQuery.tabletPortrait`
    position: absolute;
    top: auto;
    bottom: 0;
  `}

  ${mediaQuery.tabletLandscape`
    bottom: ${spacing(-0.5)};
  `}
`;
